import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { RouterState } from './types'

export const getters: GetterTree<RouterState, RootState> = {}
